<template>
  <div class="auth">
    <el-dialog
      title="查看权限"
      width="600px"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <Tip>
         <span slot="content" class="font-h6-regular yx-color-text-primary ml-10">
              <p>1.团队总榜默认仅管理员可见，可手动设置对商务、招商运营可见，商务、招商运营只可查看总榜概括无法查看明细；</p>
			  <p>2.商务、招商运营默认可见与自己相关达人/商品/二级团长的榜单及明细，无需设置权限</p>
         </span>
      </Tip>
      <p class="mt-16 mb-16 yx-color-text-primary">
        团队总达人、二级团长、商品出单榜查看权限
      </p>
      <div class="yx-color-text-primary">
        <el-checkbox v-model="anchor" :true-label="1" :false-label="0">{{
          drName
        }}</el-checkbox>
        <el-checkbox v-model="business" :true-label="1" :false-label="0">{{
          zsName
        }}</el-checkbox>
      </div>
      <div slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { rankingSetViewConfig } from "@/api/ranking";
import { drRoleType, zsRoleType } from "@/utils/dataMap";
export default {
  components: {
    
  },
  props: ["platformId"],
  data() {
    return {
      visible: false,
      anchor: 0,
      business: 0,
      drName: drRoleType.name,
      zsName: zsRoleType.name,
    };
  },
  methods: {
    show(anchor, business) {
      this.anchor = anchor;
      this.business = business;
      this.visible = true;
    },
    async confirm() {
      const { platformId: platform_id, anchor, business } = this;
      const { code } = await rankingSetViewConfig({
        platform_id,
        anchor,
        business,
      });
      if (code !== 0) return;
      this.$message.success("权限配置获取成功");
      this.visible = false;
    },
  },
};
</script>
<style lang='less' scoped>
.auth {
  /deep/ .el-checkbox__label {
    color: @color-text-primary;
  }
}
</style>
